<template>
  <div id="page-container">
    <CFooter id="footer">
      <div>
        <a target="_blank">RAFI PAY.</a>
        <span class="ms-1">{{ new Date().getFullYear() }} </span>
      </div>

    </CFooter>
  </div>
</template>


<script>
export default {
  name: 'AppFooter',

}

</script>
